"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EngagementsActions = require("crm_data/engagements/EngagementsActions");

var _EngagementTypes = require("customer-data-objects/engagement/EngagementTypes");

var _immutable = require("immutable");

var _ownerUpdates = _interopRequireDefault(require("crm_ui/utils/ownerUpdates"));

var _TimelineConstants = require("crm_universal/timeline/TimelineConstants");

var _loggers = require("customer-data-tracking/loggers");

var _TimelineFiltersAPI = require("crm_ui/timeline/data/apis/TimelineFiltersAPI");

var _Dispatch = require("crm_data/dispatch/Dispatch");

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _fillExtraEventOptions = require("crm_ui/timeline/helpers/fillExtraEventOptions");

function updateOwners(engagement) {
  var mentionedOwners = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _immutable.List)();
  var currentOwnerIds = engagement.getIn(['associations', 'ownerIds'], (0, _immutable.List)());
  var ownerUpdates = (0, _ownerUpdates.default)(mentionedOwners, currentOwnerIds);

  if (ownerUpdates.length) {
    var engagementId = engagement.getIn(['engagement', 'id']);
    (0, _EngagementsActions.updateAssociations)(engagementId, ownerUpdates);

    _loggers.CrmLogger.log('indexUsage', {
      action: 'use @mention'
    });
  }
}

function updateAttachments(engagement, partialEngagement) {
  var engagementId = engagement.getIn(['engagement', 'id']);
  var type = engagement.getIn(['engagement', 'type']);

  if ([_EngagementTypes.NOTE, _EngagementTypes.CALL, _EngagementTypes.EMAIL, _EngagementTypes.MEETING].indexOf(type) > -1) {
    var newAttachments = partialEngagement.get('attachments');
    var oldAttachments = engagement.get('attachments');

    if (newAttachments && oldAttachments !== newAttachments) {
      engagement = engagement.set('attachments', newAttachments);
      (0, _Dispatch.dispatchQueue)(_ActionTypes.ENGAGEMENTS_ATTACHMENTS_UPDATED, (0, _immutable.Map)().set(engagementId, engagement));
    }
  }
}

var _default = {
  clearFilters: function clearFilters(objectType) {
    (0, _Dispatch.dispatchImmediate)(_ActionTypes.TIMELINE_CLEAR_FILTERS, objectType);
  },
  enableFavoriteEvent: function enableFavoriteEvent(objectType, engagementType) {
    var favoriteEvent = _TimelineConstants.FAVORITE_ENGAGEMENT_TYPES.get(engagementType);

    if (favoriteEvent) {
      (0, _Dispatch.dispatchImmediate)(_ActionTypes.ENABLE_FAVORITE_EVENT, {
        favoriteEvent: favoriteEvent,
        objectType: objectType
      });
    }
  },
  overrideFavoriteEvent: function overrideFavoriteEvent(objectType, eventTypes, requestPayload) {
    (0, _Dispatch.dispatchImmediate)(_ActionTypes.SET_FAVORITE_EVENT_OVERRIDE, {
      objectType: objectType,
      eventTypes: eventTypes,
      requestPayload: requestPayload
    });
  },
  clearFavoriteEventOverride: function clearFavoriteEventOverride(objectType) {
    (0, _Dispatch.dispatchImmediate)(_ActionTypes.CLEAR_FAVORITE_EVENT_OVERRIDE, {
      objectType: objectType
    });
  },
  addEngagement: function addEngagement(engagement) {
    engagement = (0, _immutable.fromJS)(engagement);
    (0, _Dispatch.dispatchImmediate)(_ActionTypes.ADD_ENGAGEMENT, {
      engagement: engagement
    });
  },
  updateTimelineFavoritedEvents: function updateTimelineFavoritedEvents(objectType, newEventTypes, requestPayload) {
    var eventTypesToSave = (0, _fillExtraEventOptions.fillExtraEventOptions)(objectType, newEventTypes);
    (0, _TimelineFiltersAPI.save)(objectType, eventTypesToSave);

    _loggers.CrmLogger.logRecordInteraction(objectType, {
      action: 'filtered timeline'
    });

    (0, _Dispatch.dispatchImmediate)(_ActionTypes.CHANGE_FILTER, {
      objectType: objectType,
      newEventTypes: newEventTypes,
      requestPayload: requestPayload
    });
  },
  updateTimelineUserAndTeamFilters: function updateTimelineUserAndTeamFilters(objectType, newEventTypes, requestPayload) {
    (0, _Dispatch.dispatchImmediate)(_ActionTypes.TIMELINE_CHANGE_USER_AND_TEAM_FILTER, {
      objectType: objectType,
      newEventTypes: newEventTypes,
      requestPayload: requestPayload
    });
  },
  deleteTimelineEngagement: function deleteTimelineEngagement(engagement) {
    var engagementId = engagement.getIn(['engagement', 'id']);
    var engagementType = engagement.getIn(['engagement', 'type']);
    return (0, _EngagementsActions.deleteEngagement)(engagementId, engagementType).then(function () {
      (0, _Dispatch.dispatchImmediate)(_ActionTypes.DELETE_TIMELINE_ENGAGEMENT, {
        engagement: engagement
      });
    });
  },
  deleteScheduledEmailEngagement: function deleteScheduledEmailEngagement(engagement) {
    var metadata = engagement.getIn(['metadata']);
    var engagementId = engagement.getIn(['engagement', 'id']);
    var senderEmail = metadata.getIn(['sender', 'email']);
    var facsimileSendId = metadata.getIn(['facsimileSendId']);
    return (0, _EngagementsActions.deleteScheduledEmailEngagement)(engagementId, senderEmail, facsimileSendId).then(function () {
      (0, _Dispatch.dispatchImmediate)(_ActionTypes.DELETE_TIMELINE_ENGAGEMENT, {
        engagement: engagement
      });
    });
  },
  hoverTimelineItem: function hoverTimelineItem(timelineItem) {
    (0, _Dispatch.dispatchImmediate)(_ActionTypes.HOVER_ITEM, {
      timelineItem: timelineItem
    });
  },
  updateTimelineEngagement: function updateTimelineEngagement(engagementId, updates) {
    (0, _EngagementsActions.updateEngagement)(engagementId, updates);
  },
  saveEngagementFromAutosave: function saveEngagementFromAutosave(engagement, partialEngagement, mentionedOwners) {
    if (mentionedOwners) {
      updateOwners(engagement, mentionedOwners);
    }

    if (partialEngagement.get('attachments')) {
      updateAttachments(engagement, partialEngagement);
    }

    (0, _EngagementsActions.editEngagement)(engagement.mergeDeep(partialEngagement), engagement);
  },
  // DEPRECATE in favor of EngagementsV2Actions#updateEngagement
  saveTimelineEngagement: function saveTimelineEngagement(engagement, partialEngagement, mentionedOwners) {
    updateOwners(engagement, mentionedOwners);
    updateAttachments(engagement, partialEngagement);
    var updatedEngagement = engagement.mergeDeep(partialEngagement);
    (0, _EngagementsActions.editEngagement)(updatedEngagement, engagement);
  }
};
exports.default = _default;
module.exports = exports.default;